import { defineComponent as _defineComponent } from 'vue'
import { getEngravingSetting } from '@/apis/engravingSettings'
import {
  getPreferencesSetting,
  savePreferencesSetting,
} from '@/apis/materialList'
import {
  deleteTagSetting,
  getTagTemplateList,
  loadTagSetting,
} from '@/apis/tag'
import gFolderChooseModal from '@/components/g-folder-choose-modal.vue'
import gTaskLoading from '@/components/g-task-loading.vue'
import breadcrumb from '@/components/topBreadCrumb.vue'
import router from '@/router'
import store from '@/store'
import preferencesSetting from '@/store/modules/preferencesSetting'
import { bigPlankTemp } from '@/util/bigPlankTemp'
import { translate } from '@/util/commonFun'
import { buryPointApi, getOriginRect, modalMsg } from '@/util/commonFuncs'
import defaultTagData, { defaultPaibanData } from '@/util/defaultTagData'
import { getDeviceXDPI, mmToPx, pxTomm } from '@/util/exportFuncs'
import { savaFileToDisk } from '@/util/fileSystem/generateFile'
import { dealTaskLoading } from '@/util/plankCommonFuncs'
import {
  generateTagFile,
  getFileSetting,
} from '@/util/productionDataGenerate/tagDataGenerate'
import { genFirstLevelFileName } from '@/util/tag'
import { base64ToBlob } from '@yige/utils'
import FileSaver from 'file-saver'
import JSZip from 'jszip'
import Vue, {
  computed,
  getCurrentInstance,
  onMounted,
  reactive,
  watch,
} from 'vue'
import { ref } from 'vue'

import { TagSettingType } from './type'
import { TagType, preparePrintData } from './utils/drawTag'


export default /*#__PURE__*/_defineComponent({
  __name: 'printTagNew',
  setup(__props) {

// import { GetProductionNcSetting } from '@/apis/common/productionNcSetting'
const timerRecord = ref(-1)

/** 顶部的数据筛选项 */
const filterTag = ref('all')
/** 是否标签绘制加载中 */
const isTagLoading = ref(false)
/** 是否正在导出 */
const isExporting = ref(false)
/** 导出文案 */
const exportLoadingText = ref(translate('printPage.prepareData') as string)
/** 变迁模版列表 */
const templateList = ref([] as any[])
/** 是否模版加载中 */
const isTemplateLoading = ref(false)
/** 是否加载模版设置 */
const isLoadingTempSetting = ref(false)
/** 当前激活的模版 */
const currentTagTemp = ref()
/** 标签模版数据 */
const tagTempData = ref()
/** 是否排版数据改变 */
const isPaibanDataChange = ref(false)
/** 板件标记房间排序规则 */
const roomSortWay = ref('')
/** 板件数据 */
const currentBigpart = ref(null)
/** 文件输出设置 */
const ncOutputSetting = ref<any>(null)
/** 下料文件后缀 */
const ncNameSuffix = ref('')
/** 记录上一次排版数据 */
const oriPaibanData = ref('')
/** 是否生成小板标签 */
const isGenSmallPlankTag = ref(true)
/** 导出类型 */
const exportType = ref<'image' | 'pdf'>('image')

/** 是否是彩色标签 */
const isColorfulTag = ref(false)
/** 记录任务列表 */
const taskList = ref([])
/** nc文件相关设置 */
const fileSettings = ref()
/** 本地直接下载nc文件所使用的目录被删除提示的弹窗 */
const folderChooseModalRef = ref<any>(null)
/** 标签设置 */
const tagSetting = reactive<TagSettingType>({
  /** 是否生成小板标签 */
  isGenPartTag: false,
  /** 是否自动生成余料标签 */
  isGenSurplusTag: false,
  /** 是否自动生成剩余标签 */
  isGenRestTag: false,
  /** 是否自动生成大板标签 */
  isGenBigPartTag: false,
  positionX: 0,
  positionY: 0,
  /** 是否自动生成大板文件后缀 */
  isGenBigPartFileSuffix: false,
  /** 是否镜像标签 */
  isTagMirror: false,
  /** 是否自动生成基线标签 */
  isGenBaseLine: false,
  /** 标签排序 */
  tagOrder: 1,
  /** 透明度 */
  opacity: 0.24,
  /** 特殊标记缩放大小 */
  size: 1,
  /** 默认勾选特殊标记大小自适应 */
  sizeAuto: true,
  /** 是否生成彩色标签 */
  isGenColorful: false,
})
/** 打印设置 */
const printSetting = reactive({
  /** 一页几列 */
  cols: 1,
  /** 列间距 */
  colSpace: 0,
})

/** 莫名其妙的缩放倍数，默认2倍 */
const canvasScale = 2

/** 标签图数据列表 */
const tagList = ref<TagType[]>([])

/** PDF 数据 */
const pdfSrc = ref('')
/** 标签绘制高宽 */
const tagSize = reactive({
  width: 450,
  height: 300,
})

const isVisible = ref(false)
/** 是否是内嵌云排版 */
const isWebToQt = ref(false)

const exportingText = ref(translate('printPage.prepareData') as string)
const filterOptions = ref([{ label: translate('common.all'), value: 'all' }])

/** nc设置 */
const ncSetting = computed(() => store.state.ncSetting)
/** 排版数据 */
const paibanData = computed(() => {
  return store.state.paibanData
})

const tag_canvas_wap_width = computed(() => {
  if (!tagTempData.value) return { total_width: 0, space: 0 }
  let dpi = getDeviceXDPI()
  let tag_width = mmToPx(tagTempData.value.tag_width, dpi) * canvasScale
  console.log(tagTempData.value, '=====')

  let space = mmToPx(printSetting.colSpace, dpi) * canvasScale
  // 存储一下打印设置
  localStorage.setItem('tag_print_setting', JSON.stringify(printSetting))
  return {
    total_width:
      tag_width * printSetting.cols + space * (printSetting.cols - 1),
    space,
  }
})

const renderDataList = computed(() => {
  const isGenSurplusTag = tagSetting.isGenSurplusTag
  const plankData = currentBigpart.value
    ? [currentBigpart.value]
    : paibanData.value
  const genTagData = plankData.map((data) => {
    const parts = data.parts.filter((part: any) => {
      if (!isGenSurplusTag) {
        return part.specialType !== 'supplus'
      } else {
        return true
      }
    })
    return { ...data, parts }
  })
  return genTagData
  // return tagSetting.isGenRestTag
  //   ? [...this.tagListSourceData, ...this.laveTagListSourceData]
  //   : [...this.tagListSourceData]
})

const handleFilterChange = () => {
  buryPointApi('tag', 'screen')
}

/** 导出PDF */
const handleExportPdf = async () => {
  try {
    await genTagImgList('pdf', (tagData: TagType[] | string) => {
      console.log(tagData, 'tagData')
      const zip = new JSZip()
      const pdfBlob = base64ToBlob(tagData as string)
      zip.file('tag.pdf', pdfBlob)
      // 生成压缩包
      zip.generateAsync({ type: 'blob' }).then(async (content: any) => {
        isExporting.value = false
        const name = '测试PDF'
        let flag = false
        // 是否采用zip的形式导出 否则是采用文件直接写入
        if (store.state.preferencesSetting?.setting?.is_use_folder_export) {
          const res = await savaFileToDisk(zip, name || '标签图片')
          flag = Boolean(res)
        }
        if (!flag) {
          FileSaver.saveAs(content, `${name}.zip`)
        }
      })
    })

    // zip.file('tag.pdf', pafSrc.value.split(',')[1], { base64: true })
  } catch (error) {
    console.log(error)
  }
}

/** 导出图片 */
const handleExportImg = async () => {
  console.log('导出图片')
  try {
    /** 检查本地所使用的目录是否存在 */
    const isExist = await folderChooseModalRef.value?.verify()
    if (!isExist) return

    // 按钮禁用
    const isDisable =
      isColorfulTag.value &&
      ncSetting.value.labelImageFormatNew == 'bmp' &&
      ncSetting.value.bmp_color_style == 1
    console.log(isDisable, '禁用')

    if (isDisable) {
      return
    }
    // 检测标签图片是否按大板分不同文件夹时 是否勾选了小板标签
    let newNcSetting
    if (ncSetting.value?.process_setting_id) {
      const nc_setting_res = await GetProductionNcSetting({
        setting_id: ncSetting.value?.process_setting_id,
      })
      if (nc_setting_res.data) newNcSetting = nc_setting_res.data
    }
    const { label_img_big_plank_folder, isMergeFile } =
      newNcSetting || ncSetting.value
    const isErr =
      label_img_big_plank_folder && !isMergeFile && !isGenSmallPlankTag.value

    if (isErr) {
      // Vue.prototype.$message.warning(Vue.prototype.$t('common.downImageErrTip'))
      return
    }
    buryPointApi('tag', 'export_img')
    exportType.value = 'image'
    // this.isTimeOut = true
    // await this.timer(20)
    // const time = Date.now()
    // 一级文件名
    let firstLevelFileName = ''
    let originFileNameData = {} as any
    try {
      let obj = await genFirstLevelFileName(true)
      firstLevelFileName = obj.firstLevelFileName
      originFileNameData = obj.data
    } catch (error) {}
    // 根据need_lave得到最终的图片列表
    console.log(tagList.value, 'tagList')

    let tagSrcList = tagList.value.map((item) => item.src)
    Vue.prototype.$htm_trackEvent('导出标签图片', 'click')

    isExporting.value = true
    exportLoadingText.value = '导出图片中...'
    // let time2 = Date.now();

    // 生成svg所需要的时间
    // let print_data = await this.preparePrintData("base64", 3);
    // 这儿主要用到里面的一些名字信息

    const printData = await preparePrintData(
      tagList.value,
      ncSetting.value,
      tagTempData.value,
      currentTagTemp.value,
      renderDataList.value
    )
    const imgFileName =
      originFileNameData.label_image_folder || printData.template_name
    // 创建图片转bmp实例
    const labelImage = ncSetting.value.labelImageFormatNew
    const bmp_color_style = ncSetting.value.bmp_color_style
    // 内嵌云排版执行
    console.log(typeof window.webToQt, 'window.webToQt')

    if (typeof window.webToQt !== 'undefined') {
      isExporting.value = false
      // this.showLoading = false
      // this.isPrintFlag = false
      // let originFileName = firstLevelFileName
      //   ? `${firstLevelFileName}/${imgFileName}`
      //   : print_data.template_name
      // let originFileName = imgFileName || print_data.template_name
      // 在此处判断贴标图片文件是否需要生成文件夹

      let originFileName = ''
      if (
        ncSetting.value.customizeFolder?.required_folders?.indexOf(
          'label_image_folder'
        ) !== -1
      ) {
        originFileName = imgFileName || '贴标图片'
      }
      const newConllect = [] as any[]

      window.webToQt.webLabelImgToQt({
        tagWidth: tagTempData.value.tag_width,
        tagHeight: tagTempData.value.tag_height,
        imgArr: printData.print_data.map((v, index) => {
          return {
            url:
              labelImage && labelImage === 'bmp' && bmp_color_style == 1
                ? newConllect[index].split(',')[1]
                : tagSrcList[index].split(',')[1],
            fileName: `${v.name}.${ncSetting.value.labelImageFormat || 'jpg'}`,
          }
        }),
        originFileName: `${originFileName}`,
      })
      return
    }

    let zip = new JSZip()
    let currentZip = zip
    // 收集的bmp图片数组
    const bmpList = []

    const _ncFileList = printData.ncFileList.filter(
      (i: any) => i.filetype === 'nc' && i.direction === 'front'
    )
    let idx = 0
    if (label_img_big_plank_folder && !isMergeFile) {
      let folders
      if (
        ncSetting.value.customizeFolder.required_folders?.indexOf(
          'label_image_folder'
        ) !== -1
      ) {
        folders = zip.folder(imgFileName || '贴标图片')
      }
      for (let index = 0; index < renderDataList.value.length; index++) {
        const item = renderDataList.value[index]
        const idy = _ncFileList.findIndex(
          (i: any) => i.stock_key === item.stockKey
        )
        const dirname = _ncFileList[idy].file_display_name.slice(0, -3)
        if (firstLevelFileName) {
          const zipData = (folders || zip).folder(`${dirname}`)
          if (zipData) {
            currentZip = zipData
          }
        }
        const labelImageFormatNew = ncSetting.value.labelImageFormatNew

        // 生成的每个文件夹中图片的数量
        let list = []
        // if (this.need_lave && this.gen_big_plank_tag) {
        //   list = [
        //     this.bigplantLableList[index],
        //     ...item.parts,
        //     this.LaveTagBase64List[index],
        //   ]
        // } else if (this.need_lave && !this.gen_big_plank_tag) {
        //   list = [...item.parts, this.LaveTagBase64List[index]]
        // } else if (!this.need_lave && this.gen_big_plank_tag) {
        //   list = [this.bigplantLableList[index], ...item.parts]
        // } else {
        list = [...item.parts]
        if (tagSetting.isGenBigPartTag) {
          list.unshift(item)
        }
        // }
        console.log(printData.print_data, 'print_data======')

        // 是bmp图片格式
        if (labelImageFormatNew && labelImageFormatNew === 'bmp') {
          for (let indey = 0; indey < list.length; indey++) {
            const itey = list[indey]
            let it = tagSrcList[idx].split(',')[1]
            let filename = printData.print_data[idx].name

            if (ncSetting.value.bmp_color_style) {
              let base64Str = tagSrcList[idx]
              if (indey === list.length - 1 && tagSetting.isGenRestTag) {
                // 当前文件夹余料标签的索引 = 图片列表的长度-文件夹的数量+当前生成的第几个文件夹
                const currentIndex =
                  tagSrcList.length - renderDataList.value.length + index
                base64Str = tagSrcList[currentIndex]
                filename = printData.print_data[currentIndex].name
                idx--
              }
              it = base64Str.split(',')[1]
            } else {
              if (indey === list.length - 1 && tagSetting.isGenRestTag) {
                // 当前文件夹余料标签的索引 = 图片列表的长度-文件夹的数量+当前生成的第几个文件夹
                const currentIndex =
                  tagSrcList.length - renderDataList.value.length + index
                it = tagSrcList[currentIndex].split(',')[1] // 拿到的是余料标签
                filename = printData.print_data[currentIndex].name
                idx--
              }
            }
            currentZip.file(
              `${filename}.${ncSetting.value.labelImageFormat || 'jpg'}`,
              it,
              { base64: true }
            )
            idx++
          }
        } else {
          list.forEach((itey, indey) => {
            let it = tagSrcList[idx].split(',')[1]
            let filename = printData.print_data[idx].name
            if (indey === list.length - 1 && tagSetting.isGenRestTag) {
              // 当前文件夹余料标签的索引 = 图片列表的长度-文件夹的数量+当前生成的第几个文件夹
              const currentIndex =
                tagSrcList.length - renderDataList.value.length + index
              it = tagSrcList[currentIndex].split(',')[1] // 获取到是对应的余料标签
              filename = printData.print_data[currentIndex].name
              idx--
            }
            currentZip.file(
              `${filename}.${ncSetting.value.labelImageFormat || 'jpg'}`,
              it,
              { base64: true }
            )
            idx++
          })
        }
      }
    } else {
      if (
        ncSetting.value?.customizeFolder?.required_folders?.indexOf(
          'label_image_folder'
        ) !== -1
      ) {
        const zipData = zip.folder(imgFileName || '贴标图片')
        if (zipData) {
          currentZip = zipData
        }
      }
      // 新版bmp格式
      const labelImageFormatNew = ncSetting.value.labelImageFormatNew
      if (labelImageFormatNew && labelImageFormatNew === 'bmp') {
        for (let index = 0; index < tagSrcList.length; index++) {
          let url = tagSrcList[index].split(',')[1]
          // TODO 是否为位深1生成图片
          if (ncSetting.value.bmp_color_style) {
            const newBase64 = ''
            // await exportBmp1Bit(tagSrcList[index])
            url = newBase64.split(',')[1]
          }
          currentZip.file(`${printData.print_data[index].name}.${'bmp'}`, url, {
            base64: true,
          })
        }
      } else {
        tagSrcList.forEach((item, index) => {
          item = item.split(',')[1]
          currentZip.file(
            `${printData.print_data[index].name}.${
              ncSetting.value.labelImageFormat || 'jpg'
            }`,
            item,
            { base64: true }
          )
        })
      }
    }
    // 生成压缩包
    zip.generateAsync({ type: 'blob' }).then(async (content: any) => {
      isExporting.value = false
      const name = firstLevelFileName
        ? firstLevelFileName
        : printData.template_name
      let flag = false
      // 是否采用zip的形式导出 否则是采用文件直接写入
      if (store.state.preferencesSetting?.setting?.is_use_folder_export) {
        const res = await savaFileToDisk(zip, name || '标签图片')
        flag = Boolean(res)
      }
      if (!flag) {
        FileSaver.saveAs(content, `${name}.zip`)
      }
    })
    // 全局排版导出导出图片自动保存历史
    // this.showLoading = true
    // !this.isSubPrintTag && this.autoSaveHistory()
    // this.$message.success(translate('common.downloadDoneByType'))
    // this.isTimeOut = false
    isExporting.value = false
    // this.isPrintFlag = false
    // this.export_loading = false
    // this.export_loading_text = translate('common.exportPic')
  } catch (error) {
    console.log(error, '=====')
  }
}

/** 直接打印 */
const handlePrintPre = () => {
  console.log('打印预览')
}

/** 获取模板列表 **/
const getTemplateList = async () => {
  const res = await getTagTemplateList({ limit: 100, page: 1 })
  if (res.status == 1 && res.data && res.data instanceof Array) {
    templateList.value = [{ id: 0, name: '默认模板（60×40）' }, ...res.data]
    const tagTempList = [
      { id: 0, name: '默认标签模板', data: defaultTagData },
      ...res.data,
    ]
    store.commit('setTempList', tagTempList)
    // 现在直接使用接口里面的id就行了
    let match_templates = templateList.value.find(
      (template) => template.is_default === 1
    )
    if (match_templates) await handleSelectTemplate(match_templates)
    else await handleSelectTemplate(templateList.value[0])
  } else {
    templateList.value = [{ id: 0, name: '默认模板（60×40）' }]
    await handleSelectTemplate(templateList.value[0])
  }

  isTemplateLoading.value = false
}

const handleSelectTemplate = async (template: any) => {
  localStorage.setItem('testNowTagId', template.id)
  if (!currentTagTemp.value) currentTagTemp.value = template
  // TODO wc
  // if (template.id === currentTagTemp.value.id && !isPaibanDataChange.value)
  //   return
  timerRecord.value = Date.now()
  isPaibanDataChange.value = false
  currentTagTemp.value = template
  const currentTempId = currentTagTemp.value.id
  // 获取模板详情
  if (!currentTempId) {
    // 默认模板（40x60）
    tagTempData.value = JSON.parse(defaultTagData)
    currentTagTemp.value = { data: defaultTagData, name: '默认标签模板', id: 0 }
  } else {
    const res = await loadTagSetting({ id: template.id, default: 1 })
    isLoadingTempSetting.value = false
    tagTempData.value = res.data.data

    tagTempData.value?.tem_data.forEach((item: any) => {
      if (item.data && item.data.source_data == 'oSize') {
        item.data = { ...item.data, text: '2440X1220X18' }
      }
      if (item.data && item.data.source_data == 'plankSize') {
        item.data = { ...item.data, text: '2440*1220*18' }
      }
      if (item.type === 'Typography') {
        // 将字体大小数据存进store
        store.commit('setfrontLabelFont', {
          fontSize: item.data?.textItems[0]?.fontSize,
          fontPt: item.data?.textItems[0]?.fontPt,
          fontFamily: item.data?.textItems[0]?.fontFamily,
          fontWeight: item.data?.textItems[0]?.fontWeight,
        })
      }
      // 选择了柜体排序（按房间排序的话），此处存储上房间序号的规则
      if (item.type === 'wardrobeNum') {
        roomSortWay.value = item.data.roomSortWay
      }
    })
    const barCode = tagTempData.value.tem_data.find(
      (it: any) => it.type === 'Onecode' && it.data.code_type === 'EAN13'
    )

    if (barCode && ncSetting.value.genSimpleLabelBarcode) {
      modalMsg(
        translate('printPage.simplifyOneCodeTip'),
        'warning',
        translate('common.warning'),
        handleEditTemplate as any,
        {
          okText: translate('printPage.toEdit'),
          maskClosable: true,
          closable: true,
        }
      )
    }
  }

  store.commit('setCurTemplate', currentTagTemp.value)
  // 重置 tag_svg_list ，防止页面跳动
  tagList.value = []
  // return
  if (!ncSetting.value?.process_setting_id) {
    genTagImgList()
    return
  }
  const res = await getEngravingSetting({
    setting_id: ncSetting.value.process_setting_id,
  })
  ncOutputSetting.value = res.data.ncOutputSetting
  ncNameSuffix.value = ncOutputSetting.value.fileType.fileNameType.toLowerCase()

  if (!router.currentRoute.query.from) {
    const [pt1, pt2] =
      res.data.labelingSetting && res.data.labelingSetting.label_resolution
    // 如果有设置分辨率则不采用尺寸
    if (pt1 && pt2) {
      tagTempData.value.tag_width = pxTomm(pt1 / 4, getDeviceXDPI())
      tagTempData.value.tag_height = pxTomm(pt2 / 4, getDeviceXDPI())
    }
  }
  genTagImgList()
}

/** 编辑标签模版 */
const handleEditTemplate = () => {
  buryPointApi('tag', 'editor_tag')
  if (!currentTagTemp.value.id) {
    Vue.prototype.$message({ message: '默认标签不可编辑' })
    return
  }
  Vue.prototype.$htm_trackEvent('编辑标签模板', 'click')
  // 标签管理页面进入的添加模板参数，用于活跃菜单的判断
  let from = router.currentRoute.query.from ? 'temp' : undefined
  router.push({
    path: '/editTagTem',
    query: {
      id: currentTagTemp.value.id,
      from,
    },
  })
}

// 筛选数据
const selectViewData = (data: any[]) => {
  if (filterTag.value && filterTag.value !== 'all') {
    let finalData = data.filter((item) => {
      const stockKey = item.stockKey.split(':').slice(0, 3).join(':')
      return stockKey === filterTag.value
    })
    return finalData
  }
  return data
}

/** 生成标签图片 */
const genTagImgList = async (
  tagType: 'image' | 'pdf' = 'image',
  callBack: (tagData: TagType[] | string) => any = () => []
) => {
  // const cur = getCurrentInstance()?.proxy
  isTagLoading.value = true
  const lifeFuncObj = {
    loadSetting: dealTaskLoading(
      `${translate('arrangedPage.loadding')}:${translate(
        'arrangedPage.loadSetting'
      )}`,
      `${translate('arrangedPage.finish')}:${translate(
        'arrangedPage.loadSetting'
      )}`,
      'loadSetting',
      '',
      'taskList',
      taskList.value
    ),
    loadPreferences: dealTaskLoading(
      `${translate('arrangedPage.loadding')}:${translate(
        'arrangedPage.loadPreference'
      )}`,
      `${translate('arrangedPage.finish')}:${translate(
        'arrangedPage.loadPreference'
      )}`,
      'loadPreferences',
      '',
      'taskList',
      taskList.value
    ),
    dealTemp: dealTaskLoading(
      `${translate('arrangedPage.loadding')}:${translate(
        'arrangedPage.dealTemplate'
      )}`,
      `${translate('arrangedPage.finish')}:${translate(
        'arrangedPage.dealTemplate'
      )}`,
      'dealTemp',
      '',
      'taskList',
      taskList.value
    ),
    initialData: dealTaskLoading(
      `${translate('arrangedPage.loadding')}:${translate(
        'arrangedPage.initTagData'
      )}`,
      `${translate('arrangedPage.finish')}:${translate(
        'arrangedPage.initTagData'
      )}`,
      'initialData',
      '',
      'taskList',
      taskList.value
    ),
    dealDrawData: dealTaskLoading(
      `${translate('arrangedPage.loadding')}:${translate(
        'arrangedPage.prepareDrawData'
      )}`,
      `${translate('arrangedPage.finish')}:${translate(
        'arrangedPage.prepareDrawData'
      )}`,
      'dealDrawData',
      '',
      'taskList',
      taskList.value
    ),
  }
  // const data = currentBigpart.value ? [currentBigpart.value] : paibanData.value
  const data = renderDataList.value
  console.log(tagSetting, 'tagSetting')

  const res = await generateTagFile(
    data,
    currentTagTemp.value,
    store,
    {
      isTag: tagType === 'image',
      isPdf: tagType === 'pdf',
    },
    {},
    null,
    {
      isNewGen: true,
      tagSetting: tagSetting,
      callBackFunc: function (
        tagData: { isFinished: boolean; data: TagType[] } | string
      ) {
        isTagLoading.value = false
        if (typeof tagData === 'string') {
          pdfSrc.value = tagData
          callBack && callBack(pdfSrc.value)
        } else {
          let arrPI = getDeviceXDPI()
          const width = mmToPx(tagTempData.value.tag_width, arrPI)
          const height = mmToPx(tagTempData.value.tag_height, arrPI)
          tagSize.height = height
          tagSize.width = width
          tagList.value = tagData
        }
      },
    }
  )

  console.log(res, 'res')
  // const picFormat = exportTag(
  //   {
  //     templateData: JSON.stringify(tagTempData.value),
  //     paibanData: currentBigpart.value
  //       ? [currentBigpart.value]
  //       : paibanData.value,
  //     configData: {
  //       format: ncNameSuffix.value ?? 'png',
  //       type: 'img',
  //       ncSetting: ncSetting.value,
  //       bigPlankTemp: JSON.stringify(bigPlankTemp),
  //       totalPage: 2,
  //     },
  //   },
  //   (tagData) => {
  //     isTagLoading.value = false
  //     let arrPI = getDeviceXDPI()
  //     const width = mmToPx(tagTempData.value.tag_width, arrPI)
  //     const height = mmToPx(tagTempData.value.tag_height, arrPI)
  //     tagSize.height = height
  //     tagSize.width = width
  //     tagList.value = tagData
  //     for (let i = 0; i < tagData.length; i++) {
  //       const tag = tagData[i]
  //       // console.log(tag)
  //     }
  //   }
  // )
  return []
}

/** 添加模版 */
const handleAddTemplate = () => {
  Vue.prototype.$htm_trackEvent('添加标签模板', 'click')
  buryPointApi('tag', 'add')
  router.push({ path: '/editTagTem' })
}

/** 删除模版 */
const handleDeleteTemplate = () => {
  isVisible.value = true
  buryPointApi('tag', 'delete')
  if (!currentTagTemp.value.id) {
    Vue.prototype.$message({
      duration: 1000,
      message: '默认模板不能删除',
      type: 'warning',
    })
    return
  }
}

/** 确认删除 */
const handleDelateTemplate = async () => {
  const res = await deleteTagSetting({ id: currentTagTemp.value.id })
  if (res.status != 1) return
  Vue.prototype.$message({
    duration: 1000,
    message: translate('common.deleteSuccess'),
    type: 'success',
  })
  let index = templateList.value.findIndex(
    (v) => v.id === currentTagTemp.value.id
  )
  handleSelectTemplate(templateList.value[index - 1])
  templateList.value.splice(index, 1)
  isVisible.value = false
}

/**  修改了标签设置 */
const handleChangeTagSetting = async () => {
  console.log('修改标签设置')
  // store.dispatch('preferencesSetting/updateSetting')
  await savePreferencesSetting({ tagSetting })

  // 刷新标签列表重新绘制
  refreshTagList()
}
/** 修改了打印设置 */
const handleChangePrintSetting = async () => {
  console.log('修改打印设置')
  await savePreferencesSetting({ printSetting })
}

const refreshTagList = async () => {
  genTagImgList()
}

const translateLang = (key: string, val?: any) => {
  return translate(key, val)
}

onMounted(async () => {
  // 获取偏好设置进行数值初始化，优化后此处需调整
  // const preferencesSetting = store.state.preferencesSetting

  const res = await getPreferencesSetting()

  if (res.status) {
    const preferencesSetting = res.data
    Object.assign(tagSetting, preferencesSetting.tagSetting)
  }

  const win = window as any
  isWebToQt.value = Boolean(win.webToQt)
  await getTemplateList()
  fileSettings.value = await getFileSetting(store)
})

return { __sfc: true,timerRecord, filterTag, isTagLoading, isExporting, exportLoadingText, templateList, isTemplateLoading, isLoadingTempSetting, currentTagTemp, tagTempData, isPaibanDataChange, roomSortWay, currentBigpart, ncOutputSetting, ncNameSuffix, oriPaibanData, isGenSmallPlankTag, exportType, isColorfulTag, taskList, fileSettings, folderChooseModalRef, tagSetting, printSetting, canvasScale, tagList, pdfSrc, tagSize, isVisible, isWebToQt, exportingText, filterOptions, ncSetting, paibanData, tag_canvas_wap_width, renderDataList, handleFilterChange, handleExportPdf, handleExportImg, handlePrintPre, getTemplateList, handleSelectTemplate, handleEditTemplate, selectViewData, genTagImgList, handleAddTemplate, handleDeleteTemplate, handleDelateTemplate, handleChangeTagSetting, handleChangePrintSetting, refreshTagList, translateLang, gFolderChooseModal, breadcrumb }
}

})